import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
import { TodayOfferCard } from './TodayOfferCard';
const VALUE_STACK_CHECKOUT_URL = 'https://chimica-visiva2026.impultienda.ar/checkout';
const rows = [{
  label: 'Volume 1 — Materia e trasformazioni',
  price: '47 USD'
}, {
  label: 'Volume 2 — Struttura atomica e periodicità',
  price: '47 USD'
}, {
  label: 'Volume 3 — Legami chimici e struttura molecolare',
  price: '47 USD'
}, {
  label: 'Volume 4 — Reazioni chimiche e stechiometria',
  price: '47 USD'
}, {
  label: 'Volume 5 — Chimica organica e biosistemi',
  price: '47 USD'
}, {
  label: 'Bonus 1 — Chimica in gioco™',
  price: '47 USD'
}, {
  label: 'Bonus 2 — Chimica in azione™',
  price: '47 USD'
}, {
  label: 'Bonus 3 — Valutazione formativa™',
  price: '47 USD'
}, {
  label: 'Bonus 4 — Aula di chimica visiva™',
  price: '47 USD'
}];
export function ValueStack() {
  return <section id="get-access" className="w-full scroll-mt-20 bg-white px-5 py-12 sm:py-20" data-id="element-224" data-mp="35q50qy4z0r8l">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      amount: 0.2
    }} transition={{
      duration: 0.5
    }} className="mx-auto max-w-[600px]" data-id="element-225" data-mp="1tgekc26d7sus">
        <h2 className="text-center font-serif-display text-2xl font-bold text-ink sm:text-4xl" data-id="element-226" data-mp="23797r9vckyht">
          Tutto ciò che ricevi oggi
        </h2>

        <div className="mt-6 rounded-2xl border border-cobalt/25 p-4 sm:mt-8 sm:p-6" data-id="element-227" data-mp="2c5bd21m46daw">
          <ul data-id="element-228" data-mp="284j3t8d8s8em">
            {rows.map(row => <li key={row.label} className="flex items-center justify-between gap-3 border-b border-dashed border-cobalt/20 py-2 last:border-b-0 sm:py-2.5" data-id="element-229" data-mp="283pt5wb5wyr7">
                <span className="text-[13px] text-ink/80 sm:text-sm" data-id="element-230" data-mp="2h5qpmqykngrt">{row.label}</span>
                <span className="shrink-0 text-[13px] font-medium text-ink/60 sm:text-sm" data-id="element-231" data-mp="rqj7s8hip2wn">
                  {row.price}
                </span>
              </li>)}
          </ul>

          <div className="my-4 h-px w-full bg-cobalt/30" data-id="element-232" data-mp="2muh7xle5quxd" />

          <div className="flex items-center justify-between" data-id="element-233" data-mp="2rrz7il6abxsp">
            <span className="text-[13px] text-ink/60 sm:text-sm" data-id="element-234" data-mp="2rsip20s0wk67">Valore complessivo</span>
            <span className="text-lg font-medium text-ink/50 line-through sm:text-xl" data-id="element-235" data-mp="2vsj51purt3fd">423 USD</span>
          </div>

          <div className="mt-4 flex flex-col items-center rounded-xl bg-cobalt/10 py-5 text-center sm:py-6" data-id="element-236" data-mp="30qufa1oz9fy4">
            <span className="text-sm font-medium text-cobalt-deep" data-id="element-237" data-mp="35q79x8m3brb9">Prezzo di oggi</span>
            <span className="font-serif-display text-5xl font-bold text-cobalt sm:text-6xl" data-id="element-238" data-mp="3ap0egbjeg7za">
              27 USD
            </span>
            <p className="mt-2 px-4 text-xs font-medium text-ink/70 sm:text-sm" data-id="element-239" data-mp="3jjyb9tpo44vw">
              Pagamento unico · Nessun abbonamento · Accesso senza scadenza
            </p>
            <p className="mt-1 px-4 text-xs text-ink/60 sm:text-sm" data-id="element-240" data-mp="3ogorqi5dx2hu">
              Consegna digitale immediata tramite e-mail
            </p>
            <p className="mt-1 px-4 text-xs text-ink/60 sm:text-sm" data-id="element-241" data-mp="7gf2n9fth9ua">
              Prodotto digitale: non verrà spedito alcun materiale fisico
            </p>
          </div>
        </div>

        <div className="mt-6 sm:mt-8" data-id="element-242" data-mp="3tmtvsv90dz0s">
          <div className="mb-8 flex flex-col items-center text-center" data-id="element-243" data-mp="3tnvglrfttzvp">
            <span className="text-xs font-bold uppercase tracking-widest text-cobalt-deep" data-id="element-244" data-mp="3pmtixf1k5vvu">
              Uno sguardo all’interno del sistema
            </span>
            <h3 className="mt-2 font-serif-display text-2xl font-bold leading-tight text-ink sm:text-3xl" data-id="element-245" data-mp="l7jw1tsld5w6">
              Anteprima dei materiali di <span className="text-cobalt" data-id="element-246" data-mp="gfs4ph1m2w4z">CHIMICA VISIVA™</span>
            </h3>
            <p className="mt-2 text-base font-medium text-ink/70 sm:text-lg" data-id="element-247" data-mp="cfrr1ymc6oyz">
              Schede teoriche visuali, attività, laboratori e verifiche già organizzati per argomento
              e pronti da stampare.
            </p>

            <div className="mt-6 w-full overflow-hidden rounded-xl border border-cobalt/20 bg-paper shadow-sm" data-id="element-248" data-mp="145mic0tr8oqa">
              <video src="https://cdn.magicpatterns.com/uploads/g1NWacFPQ1jPQcuVCViXiA/visual-chemistry-landing-optimized.mp4" autoPlay loop muted playsInline className="aspect-square w-full object-cover" data-id="element-249" data-mp="on3b39112cly" />
            </div>
          </div>

          <CTAButton label="OTTIENI IL SISTEMA DIDATTICO COMPLETO" href={VALUE_STACK_CHECKOUT_URL} external data-id="element-250" data-mp="17ee0flr3uhbq" />
          <TodayOfferCard data-id="element-251" data-mp="1cd7i7qdfcuhp" />
          <div className="mt-4 rounded-xl border border-cobalt/20 bg-cobalt/5 px-4 py-3 text-center" data-id="element-252" data-mp="ymkipvzub0kk">
            <p className="text-sm font-bold text-cobalt-deep" data-id="element-253" data-mp="12nxltybjspns">🔒 Pagamento sicuro</p>
            <p className="mt-1 text-xs leading-relaxed text-ink/70 sm:text-sm" data-id="element-254" data-mp="12ltboyn22uf2">
              Sono accettate le principali carte di credito e di debito. Il pagamento di 27 USD viene
              elaborato in modo sicuro.
            </p>
            <p className="mt-2 text-xs leading-relaxed text-ink/60" data-id="element-255" data-mp="3fu3ykmrbfri1">
              Dove disponibile, l’importo può essere mostrato automaticamente nella valuta locale.
            </p>
          </div>
        </div>
      </motion.div>
    </section>;
}